import Glide, {
    Autoplay,
    Controls,
} from "@glidejs/glide/dist/glide.modular.esm";

export default class intro {
    constructor(elem) {
        this.slider = elem.querySelector(".js-intro-glide");
        this.caption = elem.querySelector(".js-intro-caption");

        this.siteWrapper = document.querySelector(".js-site-wrapper");
        if (this.siteWrapper) {
            this.siteWrapper.classList.add("has--intro");
        }

        if (this.slider) {
            this.setSlider();
        }
    }

    setSlider() {
        const glide = new Glide(this.slider, {
            type: "carousel",
            autoplay: 6000,
            animationDuration: 0,
            hoverpause: false,
            perview: 1,
        });

        if (this.caption) {
            const targets = this.slider.querySelectorAll(
                ".glide__slide:not(.glide__slide--clone)"
            );

            const self = this;

            glide.on(["mount.after", "run"], function () {
                const captionText = targets[glide.index].dataset.slideCaption;

                if (captionText) {
                    self.caption.classList.add("fadeout--down");
                    setTimeout(function () {
                        self.caption.innerHTML = captionText;
                        setTimeout(function () {
                            self.caption.classList.remove("fadeout--down");
                        }, 200);
                    }, 200);
                }
            });
        }

        glide.mount({ Autoplay, Controls });
    }
}
